(function () {
  'use strict';

  function initFaq(root) {
    var items = root.querySelectorAll('.dh-faq-main__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.dh-faq-main__trigger');
      var panel = item.querySelector('.dh-faq-main__panel');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.dh-faq-main__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dh-faq]').forEach(initFaq);
  });
})();
